export const replaceChainId = (markdown: string, chainId?: string): string => {
    if (!chainId) {
        return markdown;
    }
    return markdown.replace(/#\{chainId\}/g, chainId ?? '');
};
